import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "mobx-react";
import Router from "./router";
import store from "@store/index";
import Scrollbars from "react-custom-scrollbars";
import PubSub from "@common/utils/pubsub";
import { setAxios, setProxyHost } from "fe-toolkit";
import "@common/utils/dom";
import { initKeys, initOptions, initUserId } from "one-amplitude";
import http, { initCollectApiInfo } from "@common/utils/http";
import { AmplitudeProjectName } from "@common/enums";
import { iframePostMessage } from '@common/utils';
import { PostMessageType } from "@common/enums";
window.store = store;
var scrollBar = null;
PubSub.subscribe("scrollto", function (top) {
    var fn = function () {
        scrollBar.scrollTop(top);
    };
    setTimeout(fn, 200);
});
setProxyHost("http://localhost:3003");
setAxios(http);
var defaultProjectName = AmplitudeProjectName.Default;
initKeys([
    {
        host: 'ihrsp-onedev.lessen.com',
        key: 'ef3e46a62eccd6dd687b1e63b0cba5a2'
    },
    {
        host: 'ihrsp-onestage.lessen.com',
        key: 'ef3e46a62eccd6dd687b1e63b0cba5a2'
    },
    {
        host: 'ihrsp-onetest.lessen.com',
        key: 'ef3e46a62eccd6dd687b1e63b0cba5a2'
    },
    {
        host: 'ihrsp-one.lessen.com',
        key: 'ef3e46a62eccd6dd687b1e63b0cba5a2'
    },
    {
        host: 'localhost:8085',
        key: 'ef3e46a62eccd6dd687b1e63b0cba5a2'
    },
    {
        host: 'rsp-onedev.lessen.com',
        key: 'ef3e46a62eccd6dd687b1e63b0cba5a2'
    },
    {
        host: 'rsp-onestage.lessen.com',
        key: 'ef3e46a62eccd6dd687b1e63b0cba5a2'
    },
    {
        host: 'rsp-onetest.lessen.com',
        key: 'ef3e46a62eccd6dd687b1e63b0cba5a2'
    },
    {
        host: 'rsp-one.lessen.com',
        key: 'ef3e46a62eccd6dd687b1e63b0cba5a2'
    },
    {
        host: 'gpsrsp-one.lessen.com',
        key: 'ef3e46a62eccd6dd687b1e63b0cba5a2'
    },
    {
        host: 'hparsp-one.lessen.com',
        key: 'ef3e46a62eccd6dd687b1e63b0cba5a2'
    }
], defaultProjectName);
initUserId(defaultProjectName);
initOptions({ apiEndpoint: 'api2.amplitude.com' }, defaultProjectName);
var projectName = "Coca-cola";
initKeys([
    {
        host: 'ihrsp-onedev.lessen.com',
        key: 'c8cc8e393919f620a53cf5704fab3973'
    },
    {
        host: 'ihrsp-onestage.lessen.com',
        key: 'c8cc8e393919f620a53cf5704fab3973'
    },
    {
        host: 'ihrsp-onetest.lessen.com',
        key: 'c8cc8e393919f620a53cf5704fab3973'
    },
    {
        host: 'ihrsp-one.lessen.com',
        key: 'a49c7a1b3f5cc900ae58f6d116789bc4'
    },
    {
        host: 'localhost:8085',
        key: 'c8cc8e393919f620a53cf5704fab3973'
    },
    {
        host: 'rsp-onedev.lessen.com',
        key: 'c8cc8e393919f620a53cf5704fab3973'
    },
    {
        host: 'rsp-onestage.lessen.com',
        key: 'c8cc8e393919f620a53cf5704fab3973'
    },
    {
        host: 'rsp-onetest.lessen.com',
        key: 'c8cc8e393919f620a53cf5704fab3973'
    },
    {
        host: 'rsp-one.lessen.com',
        key: 'a49c7a1b3f5cc900ae58f6d116789bc4'
    },
    {
        host: 'gpsrsp-one.lessen.com',
        key: 'a49c7a1b3f5cc900ae58f6d116789bc4'
    },
    {
        host: 'hparsp-one.lessen.com',
        key: 'a49c7a1b3f5cc900ae58f6d116789bc4'
    }
], projectName);
initUserId(projectName);
initOptions({ apiEndpoint: 'api2.amplitude.com' }, projectName);
var arkOTPProjectName = AmplitudeProjectName.ARK_RSP_OTP;
initKeys([
    {
        host: 'arkhomesforrentrsp-onedev.lessen.com',
        key: 'fdc3caa831581b0d9fcbfc832754ebc0'
    },
    {
        host: 'arkhomesforrentrsp-onestage.lessen.com',
        key: 'fdc3caa831581b0d9fcbfc832754ebc0'
    },
    {
        host: 'arkhomesforrentrsp-onetest.lessen.com',
        key: 'b2ef406294772eb89610eb3ccadf80e9'
    },
    {
        host: 'arkhomesforrentrsp-one.lessen.com',
        key: 'b2ef406294772eb89610eb3ccadf80e9'
    },
    {
        host: 'localhost:8085',
        key: 'fdc3caa831581b0d9fcbfc832754ebc0'
    },
    {
        host: 'rsp-onedev.lessen.com',
        key: 'fdc3caa831581b0d9fcbfc832754ebc0'
    },
    {
        host: 'rsp-onestage.lessen.com',
        key: 'fdc3caa831581b0d9fcbfc832754ebc0'
    },
    {
        host: 'rsp-onetest.lessen.com',
        key: 'b2ef406294772eb89610eb3ccadf80e9'
    },
    {
        host: 'rsp-one.lessen.com',
        key: 'b2ef406294772eb89610eb3ccadf80e9'
    }
], arkOTPProjectName);
initUserId(arkOTPProjectName);
initOptions({ apiEndpoint: 'api2.amplitude.com' }, arkOTPProjectName);
var newLoginProjectName = AmplitudeProjectName.NewLogin;
initKeys([
    {
        host: 'ihrsp-onedev.lessen.com',
        key: 'b080b7350e4dd581265dd4e874419088'
    },
    {
        host: 'ihrsp-onestage.lessen.com',
        key: 'b080b7350e4dd581265dd4e874419088'
    },
    {
        host: 'ihrsp-onetest.lessen.com',
        key: 'b080b7350e4dd581265dd4e874419088'
    },
    {
        host: 'ihrsp-one.lessen.com',
        key: 'e64c369d6ef4cf47f600b2b07af35bad'
    },
    {
        host: 'localhost:8085',
        key: 'b080b7350e4dd581265dd4e874419088'
    },
    {
        host: 'rsp-onedev.lessen.com',
        key: 'b080b7350e4dd581265dd4e874419088'
    },
    {
        host: 'rsp-onestage.lessen.com',
        key: 'b080b7350e4dd581265dd4e874419088'
    },
    {
        host: 'rsp-onetest.lessen.com',
        key: 'b080b7350e4dd581265dd4e874419088'
    },
    {
        host: 'rsp-one.lessen.com',
        key: 'e64c369d6ef4cf47f600b2b07af35bad'
    },
    {
        host: 'gpsrsp-one.lessen.com',
        key: 'e64c369d6ef4cf47f600b2b07af35bad'
    },
    {
        host: 'hparsp-one.lessen.com',
        key: 'e64c369d6ef4cf47f600b2b07af35bad'
    }
], newLoginProjectName);
initUserId(newLoginProjectName);
initOptions({ apiEndpoint: 'api2.amplitude.com' }, newLoginProjectName);
initCollectApiInfo(http);
iframePostMessage(PostMessageType.Init_Page_Info);
// Frequent-refresh guard. Disabled for now: the KO host page (Views/MRsp/Index.cshtml)
// still loads scripts/shared/refresh_util/refresh_util.js, which guards this app already.
// Enabling both would share the __Refresh_Page_Key counter and trip at roughly half the
// intended refresh count, and the two disagree on the landing page (KO sends the visitor
// to /RefreshPage/Index, this one to #/account/refreshPage).
// To switch over: drop the @Scripts.Render line from that host page, then uncomment below.
// startRefreshGuard();
ReactDOM.render(React.createElement(Scrollbars, { ref: function (dom) { return (scrollBar = dom); }, autoHide: true },
    React.createElement(Provider, { store: store },
        React.createElement(Router, null))), document.body);
// 添加热模块替换(HMR)支持
if (module.hot) {
    module.hot.accept('./router', function () {
        // 重新渲染应用
        ReactDOM.render(React.createElement(Scrollbars, { ref: function (dom) { return (scrollBar = dom); }, autoHide: true },
            React.createElement(Provider, { store: store },
                React.createElement(Router, null))), document.body);
    });
}
